'use strict';
module.exports = function GoldFileEventWebSocketPoller({goldFileEventDefaultPoller, webSocketShim, goldFileHistoryModel}) {
	if (!goldFileEventDefaultPoller || !webSocketShim || !goldFileHistoryModel) {
		throw new Error('invalid-args');
	}
	let serverAggregationSize = 0;

	const obj = this,
		shouldGetChanges = () =>  serverAggregationSize > goldFileHistoryModel.getLastHistoryByte();

	Object.keys(goldFileEventDefaultPoller).forEach(prop => {
		obj[prop] = goldFileEventDefaultPoller[prop];
	});

	obj.pollForEvents = () => {
		if (!webSocketShim.isOpen() || shouldGetChanges()) {
			return goldFileEventDefaultPoller.pollForEvents();
		}
	};

	webSocketShim.addEventListener('message', (message) => {
		if (message.type === 'file:metadata' && Number.isFinite(message.aggregationSize)) {
			serverAggregationSize = Math.max(serverAggregationSize, message.aggregationSize);
			if (shouldGetChanges()) {
				goldFileEventDefaultPoller.getEventsNow();
			}

		}
	});
};
